<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/timetable-management/timetable" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>TimeTable & Calendar
            </router-link>
            <router-link to="/school/timetable-management/timetable-view" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>TimeTable
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Time Table Slots
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <div>
                    <modal :show.sync="modals.TimeTablePeriodModal" modal-classes="modal-dialog-centered modal-md">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <form role="form">
                                        <div class="card">
                                            <h5 class="card-header">Time Table Time Slot Setup</h5>
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Slot Period</label>
                                                    <input v-model="SlotPeriodVal" type="number" min="1"
                                                        class="form-control" placeholder="Slot Period" />
                                                    <small class="form-text text-muted">What time does this slot
                                                        start?</small>
                                                </div>
                                                <div class="form-group">
                                                    <label>Start Time (Time From)</label>
                                                    <input v-model="TimeFromVal" type="time" class="form-control"
                                                        placeholder="Select start time" />
                                                    <small class="form-text text-muted">What time does this slot
                                                        end?</small>
                                                </div>
                                                <div class="form-group">
                                                    <label>End Time (Time End)</label>
                                                    <input v-model="TimeEndVal" type="time" class="form-control"
                                                        placeholder="Select end time" />
                                                    <small class="form-text text-muted">What time does this slot
                                                        end?</small>
                                                </div>
                                                <div class="form-group">
                                                    <label class="cb cb-square">
                                                        <input type="checkbox" v-model="IsBreakVal">
                                                        <span class="cb-box" aria-hidden="true"><span
                                                                class="dot"></span></span>
                                                        <span>Is This a Break Period?</span>
                                                    </label>
                                                    <small class="form-text text-muted">Check if this time slot
                                                        represents a break/lunch period</small>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.TimeTablePeriodModal = false">Cancel
                            </base-button>
                            <base-button type="success" @click.prevent="SubmitData()">Submit
                            </base-button>
                        </template>
                    </modal>
                    <div>
                        <div class="card">
                            <div class="card-body">
                                <div class="justify-content-end form-inline my-3">
                                    <router-link to="/school/timetable-management/timetable-view"
                                        class="btn btn-secondary mr-2">
                                        <i class="fa fa-arrow-left-long"></i> Back to TimeTable
                                    </router-link>
                                    <button type="button" @click.prevent="OpenTimeTablePeriod" class="btn btn-default">
                                        <i class="fa fa-plus"></i> Add New
                                    </button>
                                </div>
                                <list-skeleton v-if="!TimeTableTimeSlots" :rows="3" />
                                <div v-else class="table-responsive">
                                    <table class="table table-borderless table-hover">
                                        <thead>
                                            <tr>
                                                <th>Slot Period</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                                <th>Is Break</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in TimeTableTimeSlots" :key="item.timeTableTimeSlotId">
                                                <td>{{ item.slotPeriod }}</td>
                                                <td>{{ item.timeFrom }}</td>
                                                <td>{{ item.timeEnd }}</td>
                                                <td>
                                                    <span
                                                        v-if="item.isBreak || item.IsBreak || item.is_break">Yes</span>
                                                    <span v-else>No</span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-secondary btn-sm my-2"
                                                        @click.prevent="editTimeSlot(item)">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
import moment from "moment"
export default {
    name: "TimeTablePeriod",
    components: {
        PageSpinner
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            TimeTableIdVal: localStorage.getItem("TimeTableId") || "",
            TimeTableTimeSlotIdVal: 0,
            SlotPeriodVal: 0,
            TimeFromVal: '',
            TimeEndVal: '',
            IsBreakVal: false,
            IsModified: false,
            TimeTableTimeSlots: null,
            onloader: "none",
            modals: {
                TimeTablePeriodModal: false
            }
        };
    },
    methods: {
        // normalize various time formats to "HH:mm"
        formatTime(val) {
            if (!val && val !== 0) return "";
            const str = String(val).trim();
            const m = moment(str, moment.ISO_8601, true);
            if (m.isValid()) return m.format("HH:mm");
            const alt = moment(str, ["HH:mm:ss", "HH:mm", "h:mm A", "h:mm:ss A"], true);
            if (alt.isValid()) return alt.format("HH:mm");
            const mm = str.match(/([01]?\d|2[0-3]):[0-5]\d/);
            return mm ? mm[0] : str;
        },
        OpenTimeTablePeriod() {
            this.IsModified = false;
            this.TimeTableTimeSlotIdVal = 0;
            this.SlotPeriodVal = 0;
            this.TimeFromVal = '';
            this.TimeEndVal = '';
            this.IsBreakVal = false;
            this.modals.TimeTablePeriodModal = true;
        },
        editTimeSlot(item) {
            // use safe fallbacks (avoid ?? to prevent parser issues)
            this.IsModified = true;
            this.TimeTableTimeSlotIdVal = item.timeTableTimeSlotId;
            this.SlotPeriodVal = item.slotPeriod;
            // normalize incoming time formats to HH:mm so validator accepts them
            this.TimeFromVal = this.formatTime(item.timeFrom);
            this.TimeEndVal = this.formatTime(item.timeEnd);
            this.IsBreakVal = !!(item.isBreak);
            this.modals.TimeTablePeriodModal = true;
        },
        validateTimeTableSlot() {
            const errors = [];
            const timeRe = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/; // HH:MM format

            if (!this.TimeFromVal || !this.TimeFromVal.toString().trim()) {
                errors.push("Start time is required");
            } else if (!timeRe.test(this.TimeFromVal)) {
                errors.push("Start time must be in valid HH:MM format");
            }

            if (!this.TimeEndVal || !this.TimeEndVal.toString().trim()) {
                errors.push("End time is required");
            } else if (!timeRe.test(this.TimeEndVal)) {
                errors.push("End time must be in valid HH:MM format");
            }

            if (!this.SlotPeriodVal || this.SlotPeriodVal < 1) {
                errors.push("Slot period must be a positive integer");
            }

            // Validate that TimeEnd is after TimeFrom
            if (this.TimeFromVal && this.TimeEndVal && timeRe.test(this.TimeFromVal) && timeRe.test(this.TimeEndVal)) {
                const [fromHour, fromMin] = this.TimeFromVal.split(':').map(Number);
                const [endHour, endMin] = this.TimeEndVal.split(':').map(Number);
                const fromMinutes = fromHour * 60 + fromMin;
                const endMinutes = endHour * 60 + endMin;

                if (endMinutes <= fromMinutes) {
                    errors.push("End time must be after start time");
                }
            }

            return errors;
        },
        SubmitData() {
            // run validation first
            const errors = this.validateTimeTableSlot();
            if (errors.length) {
                this.ShowAlertError(errors.join(" | "), "");
                return;
            }

            let TimeTableTimeSlotId = this.TimeTableTimeSlotIdVal;
            let TimeFrom = this.TimeFromVal;
            let TimeEnd = this.TimeEndVal;
            let IsBreak = this.IsBreakVal;
            let SlotPeriod = this.SlotPeriodVal;
            let TimeTableId = this.TimeTableIdVal;

            this.onloader = "flex";

            let userdata = {};
            let operation = '';
            // when not modified -> create, when modified -> update
            if (!this.IsModified) {
                userdata = {
                    SlotPeriod,
                    TimeFrom,
                    TimeEnd,
                    IsBreak,
                    TimeTableId
                };
                operation = 'TimeTable/CreateTimeTableTimeSlot';
            } else {
                userdata = {
                    TimeTableTimeSlotId,
                    SlotPeriod,
                    TimeFrom,
                    TimeEnd,
                    IsBreak,
                    TimeTableId
                };
                operation = 'TimeTable/UpdateTimeTableTimeSlot';
            }

            this.$store
                .dispatch(operation, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == "00") {
                        this.GetTimeTableTimeSlots();
                        this.ShowAlertSuccess('Submitted Successfully', '');
                        this.modals.TimeTablePeriodModal = false;
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }
                })
                .catch((err) => {
                    this.onloader = "none";
                    console.log(err);
                });
        },
        GetTimeTableTimeSlots() {
            this.onloader = "flex";
            let TimeTableId = this.TimeTableIdVal;
            this.$store
                .dispatch("TimeTable/GetTimeTableTimeSlots", TimeTableId)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.TimeTableTimeSlots = resp.data;
                    }
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    console.log(err);
                });
        },
    },
    mounted() {
        this.GetTimeTableTimeSlots();
    },
};
</script>
